<script setup lang="ts">
import aboutBuilding from '~/assets/scss/static/255@2x.png'
</script>

<template>
  <div class="about-panel">
    <div class="about-panel__content">
      <h3>闲来帮采购平台</h3>
      <p>
        闲来帮是国内规模最大的卡券交易、帮充代充、任务做单平台，业务涵盖虚拟卡券交易、话费充值、任务做单等。
        一直以来用心为用户服务，所涉及的产品过百种，覆盖市面上绝大多数卡券及产品。
      </p>
      <p>
        闲来帮商城为个人及企业用户提供一站式的卡券交易平台，拥有丰富的产品资源，提供丰富、低价、稳定的卡券充值采购，
        所涉及的卡券交易产品多达数百余种，涵盖市面上绝大多数礼品卡券；提供高效、安全、可靠的卡券充值服务，
        使用优惠折扣价格实现各类虚拟产品充值、省钱。
      </p>
      <p>
        还有其他更多有趣、有价值、能省钱、能赚钱的功能等待您的体验~
      </p>
    </div>

    <div class="about-panel__image" aria-hidden="true">
      <img :src="aboutBuilding" alt="" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.about-panel {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 284px;
  overflow: hidden;

  &__content {
    width: 710px;
    padding: 28px 0 46px;

    h3 {
      margin: 0 0 20px;
      color: #12233b;
      font-size: 30px;
      font-weight: 700;
      line-height: 1.3;
    }

    p {
      margin: 0;
      color: #5d7b9f;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.9;
      text-align: justify;

      & + p {
        margin-top: 6px;
      }
    }
  }

  &__image {
    width: 390px;
    height: 236px;
    margin-top: 16px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    pointer-events: none;

    img {
      display: block;
      width: 390px;
      height: auto;
      object-fit: contain;
      user-select: none;
    }
  }
}

@media (max-width: 900px) {
  .about-panel {
    align-items: center;
    flex-direction: column;
    min-height: auto;

    &__content {
      width: 100%;
      padding-bottom: 28px;
    }

    &__image {
      width: 100%;
      justify-content: center;

      img {
        width: min(405px, 100%);
      }
    }
  }
}
</style>
